<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10qil0f/tc-custom/9780802196262.jpg?1709147586650" alt="This image is the cover for the book Don't Vote"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don't Vote
      </h1>
      <p class="bookDescription body article font2">
        <b>“[A] merciless but often humorous look at the shortcomings of American politics” by the #1 <i>New York Times</i>–bestselling author of <i>Parliament of Whores</i> (<i>Booklist</i>).</b><br/>  <br/><i>Don’t Vote: It Just Encourages the Bastards</i> is a brilliant, disturbing, hilarious, and sobering look at why politics and politicians are a necessary evil—but only just barely necessary. Read P. J. O’Rourke on the pathetic nature of our attempts to govern ourselves and laugh through your tears or—what the hell—just laugh.<br/>  <br/> “Whether readers agree with O’Rourke’s politics or not, his style is funny, cutting, and insightful.” —<i>Booklist</i><br/>  <br/> “P. J. O’Rourke is like S. J. Perelman on acid.” —Christopher Buckley<br/>  <br/> “The funniest writer in America.” —<i>The Wall Street Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        P.  J. O'Rourke
      </h2>
      
      <p class="authorDescription body article">P.&#160;J. O&rsquo;Rourke has written nineteen books, including <I>Modern Manners</I>, <I>Parliament of Whores</I>, and <I>All the Trouble in the World</I>. He has written for such publications as <I>Car and Driver</I>, <I>Esquire</I>, <I>Vanity Fair</I>, <I>The New Republic</I>, <I>The New York Times Book Review</I>, <I>Parade</I>, <I>Harper&rsquo;s Magazine</I>, and <I>Rolling Stone</I>. He is currently editor-in-chief of <I>American Consequences</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Atlantic Monthly Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9df369f2